import React, { useState } from 'react'
import { about, about1, about2, about3, contact, emailContact, facebook, facebookContact, instagram, instagramContact, instagramFooter, product1, product2, product3, product4 } from '../../assets/images';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useTranslation } from 'react-i18next';


const Contact = () => {

  const { t, i18n } = useTranslation();

  const navigate = useNavigate()

  const [clientName, setclientName] = useState("");
  const [clientEmail, setclientEmail] = useState("");
  const [clientPhone, setclientPhone] = useState("");
  const [clientMessage, setclientMessage] = useState("");


  const handleSubmitContact = async (e) => {
    e.preventDefault();
  
    let inputs = { name: clientName, email: clientEmail, phone: clientPhone, message: clientMessage };
    
    try {
      console.log(inputs);
      
      // Seçilen ürünleri post isteği ile gönder
      const response = await axios.post("https://www.tanura.az/tanura/contact.php/", inputs);
      
      // Başarılı olduğunda yapılacak işlemler
      toast.success("Form göndərildi");
      
      // Clear form after successful submission
      setclientName('');
      setclientEmail('');
      setclientPhone('');
      setclientMessage('');
      
      navigate('/');
      
    } catch (error) {
      // Hata durumunda yapılacak işlemler
      console.error("Sipariş gönderilirken bir hata oluştu:", error);
      toast.error("Form göndərilərkən xəta baş verdi");
    }
  };
  return ( 
      <div className="md:max-w-container max-w-containerSm mx-auto mt-[40px] md:mt-[88px]">
    <p className="text-[22px] md:text-[28px] font-semibold text-center mb-3 md:mb-5">{t("Əlaqə")}</p>
    <p className="text-[16px] font-medium text-center mb-[22px] md:mb-10 text-[#C7C7C7] mx-auto md:w-[498px]">{t("Bizə sualınız var? Məhsullarımıza rəy bildirmək istəyirsiniz? Bizə yaza bilərsiz.")}</p>
   <div className='md:flex'>
    <div className='md:mr-[20px] md:w-[643px] md:mt-0 bg-[#C8C8C8] rounded-[24px] px-6 py-4 box-border md:h-[546px]'>
      <form onSubmit={handleSubmitContact} class="space-y-4">
      <div>
        <label for="name" class="block text-base font-medium text-[white]">{t("Ad, soyad")}*</label>
        <input
        onChange={(event) => setclientName(event.target.value)}
        value={clientName}
        required
         placeholder='Ad, soyad' type="text" id="name" class="bg-[#FBFBFB] mt-2 block w-full h-10 border border-[#dddddd] rounded-xl shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3" />

      </div>

    
      <div>
        <label for="email" class="block text-base font-medium text-[white]">{t("E-mail")}*</label>
        <input  onChange={(event) => setclientEmail(event.target.value)}
        value={clientEmail}
         required placeholder='email@gmail.com' type="email" id="email" class="bg-[#FBFBFB] mt-2 block w-full h-10 border border-[#dddddd] rounded-xl shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3 " ></input>
      </div>

      <div>
        <label for="phone" class="block text-base font-medium text-[white]">{t("Əlaqə nömrəsi")}*</label>
        <input onChange={(event) => setclientPhone(event.target.value)}
      value={clientPhone}
      required type="number" id="phone" class="bg-[#FBFBFB] mt-2  block w-full h-10 border border-[#dddddd] rounded-xl shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3 "></input>
      </div>

    <div>
      <label for="message" class="block text-base font-medium text-[white]">{t("Mesaj")}</label>
      <textarea onChange={(event) => setclientMessage(event.target.value)}
     value={clientMessage}
     required  id="message" rows="4" placeholder='Bizə yazın...' class="bg-[#FBFBFB] h-36 pl-3 pr-3 pt-3 mt-2 block w-full border border-[#dddddd] rounded-xl shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm" ></textarea>
    </div>

    <div class="flex justify-start">
      <button type="submit" class="w-[148px] h-10 p-2.5 bg-[#223077] rounded-xl justify-center items-center gap-2.5 inline-flex text-[white]">{t("Göndər")}</button>
    </div>
  </form>
    </div>
    <div className="relative md:w-[657px] flex flex-col justify-between mt-5 md:mt-0">
  <img src={contact} alt="Contact" className="w-full h-auto rounded-[8px] md:rounded-[0px]" />
  <div className='mt-[20px] bg-[#F5F5F5] rounded-[16px] grid grid-cols-2 py-2 gap-6 md:w-[481px]'>
    <div className='flex'>
      <div className='flex items-center'><img className='w-10 h-10' src={instagramFooter}></img></div>
      <div className='ml-4'>
        <p>{t("Əlaqə nömrəsi")}</p>
        <p className='text-[#bcbcbc] text-sm mt-[4px]'>+994 70 370 55 70</p>
      </div>
    </div>
    <div className='flex'>
      <div className='flex items-center'><img className='w-10 h-10' src={emailContact}></img></div>
      <div className='ml-4'>
        <p>{t("E-poçta adresi")}</p>
        <p className='text-[#bcbcbc] text-sm mt-[4px]'>info@tanura.az</p>
      </div>
    </div>
    <div className='flex'>
      <div className='flex items-center'><img className='w-10 h-10' src={instagramContact}></img></div>
      <div className='ml-4'>
        <p>Instagram</p>
        <p className='text-[#bcbcbc] text-sm mt-[4px]'>@tanura.az</p>
      </div>
    </div>
    <div className='flex'>
      <div className='flex items-center'><img className='w-10 h-10' src={facebookContact}></img></div>
      <div className='ml-4'>
        <p>Facebook</p>
        <p className='text-[#bcbcbc] text-sm mt-[4px]'>tanura.az</p>
      </div>
    </div>
  </div>
</div>
   </div>
  </div>
  )
}

export default Contact 